/**
 * Canonical tour target selectors — shared with first-time guide in a future phase.
 */
export const GUIDE_TARGETS = Object.freeze({
  ASHLEY_FAB: ".guide-ashley-fab",
  ASHLEY_LISTENING_PANEL: ".guide-ashley-listening-panel",
  ASHLEY_LISTENING_FIGURE: ".guide-ashley-listening-figure",
  QUICK_MENU: ".guide-quick-menu",
  ALL_MODULES: ".guide-all-modules",
  MODULE_BACK: ".guide-module-back",
  HELP_BUTTON: ".guide-help-button",
});
